module.exports = __webpack_public_path__ + "img/1312974659.a97897b8.jpg";